import { useEffect, useState } from "react"
import RefundForm from "../../../components/Refund-iban-form"
import WithSidebar from "../../../layouts/WithSidebar"
import { useSearchParams } from "react-router-dom"
import utils from "../../../scripts/utils"
import { useSnackbar } from "notistack"
import { ajax } from "../../../scripts/helper"

const RefundIban = () => {

    const [searchParams, setSearchParams] = useSearchParams()
    // const [detail, setDetail] = useState({})
    const id = searchParams.get('id')
    const {enqueueSnackbar} = useSnackbar()
    let detail = {}

    // useEffect ( () => {

    //     if(id) getTransactionDetail(id)
    // }, [])

        // const getTransactionDetail = async (id) => {
            
        //     const res = await ajax({
        //         method: 'GET',
        //         url: utils.urls.linkDetail(id),
        //         hasToken: true,
        //         snackbar: enqueueSnackbar
        //     })

        //     if (!res) return

        //     console.log(res.data, ' inja request mizane')

        //     detail = res.data


        //     console.log(detail, 'inja por mishe')
        // }

    return(
        <WithSidebar>
            <RefundForm  id={id}/>
        </WithSidebar>
    )
}

export default RefundIban